import { RESOLUTIONS, describeBucket } from './usageModel';

const toIso = value => new Date(value).toISOString();

const byBounds = (a, b) => (a.startAt < b.startAt ? -1 : a.startAt > b.startAt ? 1 : a.endAt < b.endAt ? -1 : a.endAt > b.endAt ? 1 : 0);

// Differing durations for the same app and interval are left unknown rather than summed or picked.
const cellValue = durations => {
  if (!durations) return null;
  return durations.every(duration => duration === durations[0]) ? durations[0] : null;
};

const toView = (resolution, records) => {
  const intervals = {};
  // appId is client-supplied, so it must not resolve Object.prototype members such as "constructor".
  const apps = Object.create(null);
  records.filter(record => record.resolution === resolution).forEach(record => {
    const startAt = toIso(record.startAt);
    const endAt = toIso(record.endAt);
    const id = `${startAt}~${endAt}`;
    const interval = intervals[id] || (intervals[id] = { id, startAt, endAt, partial: false });
    interval.partial = interval.partial || record.partial === true;
    const app = apps[record.appId] || (apps[record.appId] = { identifier: record.appId, name: null, durations: {} });
    app.name = app.name || record.name || null;
    app.durations[id] = (app.durations[id] || []).concat(record.durationMs);
  });
  const ordered = Object.keys(intervals).map(id => intervals[id]).sort(byBounds);
  const buckets = ordered.map(interval => describeBucket(resolution, interval));
  return {
    resolution,
    buckets,
    apps: Object.keys(apps).map(appId => ({
      identifier: appId,
      name: apps[appId].name,
      durationByBucket: ordered.reduce(
        (all, interval, index) => ({ ...all, [buckets[index].key]: cellValue(apps[appId].durations[interval.id]) }),
        {}
      ),
    })),
  };
};

const toSource = device => ({
  platform: device.platform,
  deviceName: device.deviceName || null,
  osVersion: device.osVersion || null,
});

export const toSnapshot = snapshot => ({
  id: snapshot.id,
  capturedAt: toIso(snapshot.capturedAt),
  timeZone: snapshot.timeZone || null,
  source: toSource(snapshot.sourceDevice),
  recordCount: snapshot.records.length,
  views: RESOLUTIONS.reduce((all, resolution) => ({ ...all, [resolution]: toView(resolution, snapshot.records) }), {}),
});



// WEBPACK FOOTER //
// ./src/features/loan-management/components/phone-usage/captureMapping.js